module.exports = __webpack_public_path__ + "static/media/door-setp.26759f22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/door-setp.svg
// module id = 676
// module chunks = 0